import React, { useState, useEffect } from 'react';

const DatePicker2 = ({ selectedDate, onDateChange, label }) => {
  const today = new Date();
  const [isOpen, setIsOpen] = useState(false);
  const [currentYear, setCurrentYear] = useState(today.getFullYear());
  const [currentMonth, setCurrentMonth] = useState(today.getMonth());
  const [inputValue, setInputValue] = useState(selectedDate || '');

  useEffect(() => {
    setInputValue(selectedDate || '');
  }, [selectedDate]);

  const toggleCalendar = e => {
    e.stopPropagation();
    setIsOpen(prev => !prev);
  };

  const handleDateClick = day => {
    const formattedDate = `${currentYear}-${String(currentMonth + 1).padStart(
      2,
      '0'
    )}-${String(day).padStart(2, '0')}`;
    onDateChange(formattedDate);
    setInputValue(formattedDate);
    setIsOpen(false);
  };

  const handlePrev = e => {
    e.stopPropagation();
    if (currentMonth === 0) {
      setCurrentYear(prev => prev - 1);
      setCurrentMonth(11);
    } else {
      setCurrentMonth(prev => prev - 1);
    }
  };

  const handleNext = e => {
    e.stopPropagation();
    if (currentMonth === 11) {
      setCurrentYear(prev => prev + 1);
      setCurrentMonth(0);
    } else {
      setCurrentMonth(prev => prev + 1);
    }
  };

  const handleInputChange = e => {
    let value = e.target.value.replace(/\D/g, ''); 

    if (value.length > 8) {
      return; 
    }

    let year = value.slice(0, 4);
    let month = value.slice(4, 6);
    let day = value.slice(6, 8);

    if (month) {
      let monthNum = parseInt(month, 10);
      if (monthNum < 0 || monthNum > 12) {
        return;
      }
    }

    if (day) {
      let dayNum = parseInt(day, 10);
      let maxDays = new Date(
        parseInt(year, 10),
        parseInt(month, 10),
        0
      ).getDate();
      if (dayNum < 0 || dayNum > maxDays) {
        return;
      }
    }

    if (value.length > 4) {
      value = value.slice(0, 4) + '-' + value.slice(4);
    }
    if (value.length > 7) {
      value = value.slice(0, 7) + '-' + value.slice(7);
    }

    setInputValue(value);

    if (value.length === 10) {
      onDateChange(value);
    }
  };


  const renderCalendarDays = () => {
    const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
    const firstDay = new Date(currentYear, currentMonth, 1).getDay();
    const days = [];

    for (let i = 0; i < firstDay; i++) {
      days.push(<td key={`prev-${i}`} className="empty" />);
    }

    for (let day = 1; day <= daysInMonth; day++) {
      days.push(
        <td key={day}>
          <button
            type="button"
            className="btn-set-date"
            onClick={() => handleDateClick(day)}
          >
            {day}
          </button>
        </td>
      );
    }

    return Array.from({ length: Math.ceil(days.length / 7) }, (_, rowIdx) => (
      <tr key={rowIdx}>{days.slice(rowIdx * 7, rowIdx * 7 + 7)}</tr>
    ));
  };

  return (
    <div className="form-group date">
      <div className="form-conts">
        <div className="datepicker-input">
          <input
            type="text"
            className="form-control md datepicker cal"
            placeholder={`${label}를 선택하세요`}
            value={inputValue}
            onClick={toggleCalendar}
            onChange={handleInputChange}
            aria-labelledby="datepicker"
          />
          <button
            type="button"
            className="form-btn-datepicker"
            onClick={toggleCalendar}
          >
            <span className="sr-only">달력 열기</span>
          </button>
        </div>
        {isOpen && (
          <div className={`datepicker-area active`}>
            <div className="datepicker-wrap bottom">
              <div className="datepicker-head">
                <button
                  type="button"
                  className="btn-cal-move prev"
                  onClick={handlePrev}
                ></button>
                <div className="datepicker-switch-wrap">
                  <span>
                    {currentYear}년 {currentMonth + 1}월
                  </span>
                </div>
                <button
                  type="button"
                  className="btn-cal-move next"
                  onClick={handleNext}
                ></button>
              </div>
              <table className="datepicker-tbl">
                <thead>
                  <tr>
                    {['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].map(day => (
                      <th key={day}>{day}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>{renderCalendarDays()}</tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DatePicker2;
